import React = require('react');
import { IconCircle } from '../../../../../components/Icons/IconCircle';
import { IPaymentMethod, IPolicy, IPremium } from '../../../../../data/api/models';
import { capitalize } from 'lodash';
import { DocumentsLinkButton } from '../DocumentsLinkButton';
import { isLuckyTripProduct } from '../../../../../helpers/TravelApplication';
import AddPaymentCard from '../../../../../components/AddPaymentCard';
import { IAuthState } from '../../../../../services/auth/models';
import { POLICY_ACTIVE_STATUSES } from '../../../../../data/api/transformers/customer';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { FaSpinner } from 'react-icons/fa';
import { format } from 'date-fns';

interface IApplicationDetailsBanner {
  text: string;
  auth?: IAuthState;
  type?: string;
  premium?: IPremium;
  totalPremium?: number;
  headerText?: string;
  tripType?: string;
  policy?: IPolicy;
  documentsUrl?: string;
  isRetrievingQuote?: boolean;
  customerLapsed?: boolean;
  handleQuoteEdit?: () => any
}

export enum applicationType {
  POLICY_DETAILS = 'policyDetails',
  QUOTED_DETAILS = 'quoteDetails',
  RENEWAL_DETAILS = 'renewalDetails'
}

export const ApplicationDetailsBanner = ({
                                           premium,
                                           text,
                                           auth = null,
                                           type = '',
                                           totalPremium = null,
                                           headerText = '',
                                           tripType = '',
                                           policy = null,
                                           documentsUrl = '',
                                           isRetrievingQuote = false,
                                           customerLapsed = false,
                                           handleQuoteEdit
                                         }: IApplicationDetailsBanner) => {


  let headerTextDisplay = headerText;
  let isAnnual;
  let quoteValidity;

  if (tripType && !premium) {
    isAnnual = tripType === 'annual'
  }

  if (!headerTextDisplay && premium) {
    const schemeType = premium.schemeType;
    const gross = premium?.gross.toFixed(2);
    const coverLevel = premium?.scheme?.coverLevel
    isAnnual = schemeType === 'Annual Multi Trip';
    headerTextDisplay = `${schemeType} ${capitalize(coverLevel)} - £${totalPremium ? totalPremium.toFixed(2) : gross}`;
  }

  if (premium?.validUntil && type && type === applicationType.QUOTED_DETAILS) {
    quoteValidity = format(new Date(premium.validUntil), 'dd/MM/yyyy')
  }

  const renderChangeCardPreference = (paymentMethod: IPaymentMethod) => {
    let title = 'ADD CARD';

    if (paymentMethod.id) {
      title = 'UPDATE CARD'
    }

    if (isLuckyTripProduct(policy)) {
      return null;
    }

    return (
      <AddPaymentCard
        buttonTitle={title}
        buttonDisabled={isRetrievingQuote}
        showSpinner={isRetrievingQuote}
        travellers={policy.travellers}
        customerId={auth.customer.id}
        policyId={policy.id}
      />
    );
  }

  const renderMakeAChangeButton = (policy: IPolicy) => {
    const isPolicyActive = POLICY_ACTIVE_STATUSES.includes(policy.status);
    if (isPolicyActive && !isLuckyTripProduct(policy) && policy.id) {
      return (
        <>
          <Link to={`/account/make-a-change/selection/${policy.id}`}>
            <Button
              bsStyle={'primary'}
              className="medium-width secondary-button">MANAGE POLICY
            </Button>
          </Link>
        </>
      );
    }
  }

  const handleEditQuote = () => {
    handleQuoteEdit();
  }

  const renderViewEditButton = (text: string = '') => {
    return (
      <>
        <Button
          bsStyle={'primary'}
          className="medium-width secondary-button"
          onClick={handleEditQuote}
          disabled={isRetrievingQuote}>
          {isRetrievingQuote && (<FaSpinner className="fa-spin"/>)}{' '}
          {text ? text : 'EDIT QUOTE'}
        </Button>
      </>
    );
  }

  const renderButtons = () => {
    switch (type) {
      case applicationType.POLICY_DETAILS:
        return (
          <>
            <div><DocumentsLinkButton documentsUrl={documentsUrl}/></div>
            <div style={{ margin: '10px 0 10px 0' }}>{renderChangeCardPreference(policy.activePaymentMethod)}</div>
            <div>{renderMakeAChangeButton(policy)}</div>
          </>
        )
      case applicationType.QUOTED_DETAILS:
        return (
          <>
            {(!customerLapsed) && (
              <div>{renderViewEditButton('CHECK DETAILS & BUY')}</div>
            )}
            <div style={{ margin: '10px 0 10px 0' }}><DocumentsLinkButton documentsUrl={documentsUrl}
                                                                          isLoading={isRetrievingQuote}/></div>
            {(!customerLapsed) && (
              <div>{renderViewEditButton()}</div>
            )}
          </>
        )
    }
  }

  return (
    <div className={'banner-header'}>
      <div className={'card-info'}>
        <div className={'banner-icon'}>
          <IconCircle iconName={isAnnual ? 'plane-annual.svg' : 'Plane.svg'} color={'blue'}/>
        </div>
        <div style={{ width: '100%' }}>
          <div className={'banner-h-text'}>{headerTextDisplay}</div>
          <div className={'banner-ref-text'}>{text}</div>
          {quoteValidity && (<div className={'banner-ref-text-validity'}>Your quote is valid until {quoteValidity}</div>)}
        </div>

      </div>
      <div className={'card-buttons'}>
        <div className={'p-d-button-wrapper'}>
          {renderButtons()}
        </div>
      </div>
    </div>
  )
}
